// extracted by mini-css-extract-plugin
export default {"header":"DAOHeader_header__5dnGv","selectIcon":"DAOHeader_selectIcon__qBUNB","switchTrack":"DAOHeader_switchTrack__WQXBl"};